'use strict';

exports.__esModule = true;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = LoginButton;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactSpinnerChildren = require('react-spinner-children');

var _reactSpinnerChildren2 = _interopRequireDefault(_reactSpinnerChildren);

var _Login = require('./Login');

var _Login2 = _interopRequireDefault(_Login);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LoginButton(props) {
  var _this = this;

  var children = props.children,
      buttonClassName = props.buttonClassName,
      iconClassName = props.iconClassName,
      icon = props.icon,
      spinner = props.spinner,
      spinnerClassName = props.spinnerClassName,
      rest = (0, _objectWithoutProperties3.default)(props, ['children', 'buttonClassName', 'iconClassName', 'icon', 'spinner', 'spinnerClassName']);


  return _react2.default.createElement(_Login2.default, (0, _extends3.default)({}, rest, {
    render: function render(_ref) {
      var isWorking = _ref.isWorking,
          isLoading = _ref.isLoading,
          onClick = _ref.onClick;
      return _react2.default.createElement(
        'button',
        {
          type: 'button',
          className: buttonClassName,
          onClick: onClick,
          disabled: isWorking || isLoading
        },
        !!icon && _react2.default.createElement('i', { className: iconClassName }),
        children,
        !!spinner && (isWorking || isLoading) && _react2.default.createElement(_reactSpinnerChildren2.default, {
          config: _this.props.spinnerConfig,
          className: spinnerClassName
        })
      );
    }
  }));
}

LoginButton.defaultProps = (0, _extends3.default)({}, _Login2.default.defaultProps, {
  spinnerConfig: {},
  buttonClassName: 'btn btn-lg',
  iconClassName: 'fa fa-facebook pull-left',
  spinner: true,
  icon: true
});
//# sourceMappingURL=LoginButton.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-facebook/lib/LoginButton.js
// module id = 862
// module chunks = 67997519577666